export const DISABLED_COOKIES_MSG =
  'Cookies are disabled in this browser. Please enable cookies and try again.';
